export const RoutesConstant = {
  DASHBOARD: '/dashboard',
  CANDIDATE_R: 'candidate',
  CANDIDATE: '/candidates/:group/candidate/:id',
  CANDIDATES: '/candidates',
  CANDIDATES_GROUP: '/candidates/:group',
  CANDIDATES_GROUPS: {
    BASE: '/candidates/base',
    COMMUNICATION: '/candidates/communication',
    REQUESTS: '/candidates/requests',
    WAIT: '/candidates/wait',
    WORK: '/candidates/work',
    SEARCH: '/candidates/search',
    ARCHIVE: '/candidates/archive',
    FAVOURITE: '/candidates/favourite',
    ALL: '/candidates/all',
  },
  INTERNSHIP_R: '/internship',
  INTERNSHIP: '/internship/:id',
  INTERNSHIPS: '/internships',
  INTERNSHIPS_GROUP: '/internships/:group',
  INTERNSHIPS_GROUPS: {
    WAIT: '/internships/wait',
    WORK: '/internships/work',
    CLOSED: '/internships/closed',
  },
  EVENTS: '/events',
  REPORT: '/report',
  CONTROL_PANEL: '/controlPanel',
  REPORT_GROUP: '/report/:group',
  REPORT_GROUPS: {
    JOB: '/report/job',
    HR: '/report/hr',
    RECRUITER: '/report/recruiter',
    STATUS: '/report/status',
    SOURCE: '/report/source',
    REGION: '/report/region',
    EXPERIENCE: '/report/experience',
  },
  HELP: '/help',
  ASSISTANT: '/assistant',
  EXTENSION: '/extension',
  PROFILE: '/profile',
  INVITATION: '/invitation/:guid',
};

export const BaseRoutes: string[] = [
  RoutesConstant.DASHBOARD,
  ...Object.values(RoutesConstant.CANDIDATES_GROUPS).filter(
    route => route !== RoutesConstant.CANDIDATES_GROUPS.SEARCH,
  ),
  RoutesConstant.INTERNSHIPS,
  RoutesConstant.EVENTS,
  ...Object.values(RoutesConstant.REPORT_GROUPS),
  RoutesConstant.CONTROL_PANEL,
  RoutesConstant.ASSISTANT,
];

export const HELP_PAGE_LINK =
  'https://jira.intexsoft.com/servicedesk/customer/portal/8/create/177';
